import type { ReactElement } from "react"
import Link from "@onestore/hel/dist/components/quarks/Link"
import { default as MarkdownText } from "@gatsby-plugin-generic-page/components/Markdown/Text"
import Media from "@gatsby-plugin-generic-page/components/Media"
import type { ProductTileProps } from "@gatsby-plugin-generic-page/fragments/productsTilesSection"
import { getBgColorClass } from "@gatsby-plugin-generic-page/fragments/udsBackgroundColor"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import getLinkProps from "@gatsby-plugin-generic-page/helpers/getLinkProps"
import { arrowRight } from "@ionos-web-design-system/icon/system"
import { Box, Icon, Text } from "@ionos-web-design-system/react"
import { usePriceTypeContext } from "~/context/PriceTypeContext"
import { cn } from "~/helpers/cn"
import isEmpty from "~/lib/isEmpty"

function ProductTile({
  icon,
  title,
  link,
  backgroundColor,
}: ProductTileProps): ReactElement<ProductTileProps> {
  const { currentPriceType } = usePriceTypeContext()
  const { textWithEmbeddedContent, ...linkProps } = getLinkProps(
    link,
    currentPriceType
  )

  const boxVisualObject = !isEmpty(icon)
    ? {
        icon: true,
        iconContent: <Media media={icon} />,
      }
    : undefined

  const bgColorClass = getBgColorClass(backgroundColor)

  return (
    <Link {...linkProps} className="contents">
      <Box
        visual={boxVisualObject}
        footer={<Icon icon={arrowRight} size="small" aria-hidden="true" />}
        className={cn(
          "uds-action-quiet h-full border--base border-1 !rounded-md shadow-bottom-xs",
          bgColorClass ?? "bg-surface-base"
        )}
      >
        <Text asChild variant="headingLg" weight="black">
          {title}
        </Text>

        {!isEmpty(textWithEmbeddedContent) ? (
          <div className="mt-6">
            <MarkdownText
              components={getBaseMarkdownOverrides({
                typography: "tiny1",
                boldTypography: "small3",
              })}
            >
              {textWithEmbeddedContent}
            </MarkdownText>
          </div>
        ) : null}
      </Box>
    </Link>
  )
}

export default ProductTile
